import Roles from '@/router/roles';
const everyone = [Roles.Admin, Roles.Technician, Roles.Subcontractor, Roles.Partner, Roles.CustomerManager];
const administrators = [Roles.Admin];
const inhouseworkers = [Roles.Admin, Roles.Technician];
//const fieldworkers = [Roles.Technician, Roles.Subcontractor, Roles.Partner];
const adminsandsubcons = [Roles.Admin, Roles.Subcontractor];
const downlineworkers = [Roles.Admin, Roles.Technician, Roles.Subcontractor];
const serviceproviders = [Roles.Admin, Roles.Technician, Roles.Subcontractor, Roles.Partner];
const matrix = {
    //Actions
    Actions: {
        //job
        createJob: downlineworkers,
        editJobDetails: downlineworkers,
        changeJobType: downlineworkers,
        completeJob: downlineworkers,
        swapJobCustomer: adminsandsubcons,
        swapJobCustomerAddress: downlineworkers,
        swapJobCustomerContact: downlineworkers,
        //subjob
        addSubjob: downlineworkers,
        editSubjob: downlineworkers,
        removeSubjob: downlineworkers,
        //customer
        createCustomer: downlineworkers,
        editCustomer: downlineworkers,
        createCustomerAddress: downlineworkers,
        editCustomerAddress: downlineworkers,
        createCustomerContact: downlineworkers,
        editCustomerContact: downlineworkers,
        //machine
        createMachine: downlineworkers,
        editMachine: downlineworkers,
    },
    //Pages
    MyPageTrunk: {
        module: everyone,
        mycar: serviceproviders,
        myaccount: everyone,
        myhourlist: serviceproviders,
        privatesettings: everyone,
    },
    JobsTrunk: {
        module: everyone,
        newjob_branch: inhouseworkers,
        viewjob_branch: everyone,
    },
    PlannerTrunk: {
        module: inhouseworkers,
    },
    ContractsTrunk: {
        module: inhouseworkers,
    },
    CustomerTrunk: {
        module: serviceproviders,
        customerlist: serviceproviders,
        viewcustomer: serviceproviders,
    },
    DashboardTrunk: {
        module: administrators,
    },
    AdminTrunk: {
        module: administrators,
        documents: administrators,
        departments: administrators,
        settings: administrators,
        jobs_branch: administrators,
        accounts_branch: administrators,
        customers_branch: administrators,
        machines_branch: administrators,
        checklists_branch: administrators,
    },
};
export default matrix;